<template>
  <div class="schedule-card">
    <p class="schedule-card_text blue">
      {{ title }}
    </p>
    <slot name="content">
      <div
        v-if="scheduleList.length > 0"
        class="schedule-card_list"
      >
        <div
          v-for="(item,itemIndex) in _scheduleList"
          :key="itemIndex"
          class="schedule-item"
          @click="$_onClick(item)"
        >
          <i :class="$_getEventTypeIcon(item.type)" />
          <div class="item-content">
            <p class="schedule-card_item-text">
              {{ item.title }}
            </p>
            <p class="schedule-card_item-text time">
              {{ item.time }}
            </p>
          </div>
        </div>
      </div>
      <p
        v-else
        class="schedule-card_text gray"
      >
        {{ emptyText }}
      </p>
    </slot>
  </div>
</template>
<script>
export default {
  name: "ScheduleCard",
  props: {
    scheduleList: {
      type: Array,
      default() {
        return [];
      },
    },
    eventTypes: {
      type: Array,
      default() {
        return [];
      },
    },
    title: {
      type: String,
      default() {
        return this.$t("行程");
      },
    },
    emptyText: {
      type: String,
      default() {
        return this.$t("這天沒有行程");
      },
    },
  },
  computed: {
    _scheduleList() {
      if (this.scheduleList.length === 0) return [];
      let scheduleWithTime = this.scheduleList.filter((item) => item.time);
      let scheduleNoTime = this.scheduleList.filter((item) => !item.time);
      scheduleWithTime = scheduleWithTime.sort((a, b) => {
        return a.time.localeCompare(b.time);
      });
      let finalSchedule = scheduleWithTime.concat(scheduleNoTime);
      return finalSchedule;
    },
  },
  methods: {
    $_getEventTypeIcon(type) {
      if (this.eventTypes.length === 0) return "icon-nav-audit-outline";
      let selectType = this.eventTypes.find((event) => event.type === type);
      return selectType.icon;
    },
    $_onClick($event) {
      this.$emit("event-click", $event);
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/schedule-card";
</style>